import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { questService } from '@/services/quest';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useQuestTypeDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        typeId: route.params.typeId,
        name: null,
        displayType: 0,
        timeUnit: 0,
        timeDuration: null,
        openCycle: null,
        restCycle: null,
        startTime: null,
        nextStartTime: null,
        canDelete: false,
        canEnable: false,
        canDisable: false,
        canDisableNext: false
    });

    const fetch = crudAction.executeAction({
        request: () => questService.type.get(model.typeId),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            data.nextStartTime = new Date(data.nextStartTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_QUEST.TYPE.INDEX })
    });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: () => questService.type.disable(model.typeId),
            onSuccess: fetch
        }),
        disableNext: crudAction.confirmAndDisable({
            confirmMessage: 'Are you sure you want to disable this type in next cycle?',
            request: () => questService.type.disableNext(model.typeId),
            onSuccess: fetch
        }),
        enableNext: crudAction.confirmAndEnable({
            confirmMessage: 'Are you sure you want to enable this type in next cycle?',
            request: () => questService.type.enableNext(model.typeId),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => questService.type.remove(model.typeId),
            onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.TYPE.INDEX })
        })
    };

    return { model, fetch, actions };
}
